export const MEDICAL_ROLE_NAMES = Object.freeze([
    'DOCTOR',
    'CLINIC_CARE_GIVER',
    'PATIENT',
    'PATIENT_CARE_GIVER'
]);

export const isMedicalRole = (role) => MEDICAL_ROLE_NAMES.includes(role?.name);

export const getMedicalRoles = (roles = []) => roles.filter(isMedicalRole);

export const getUniqueClinics = (roles = []) => {
    const clinics = new Map();

    getMedicalRoles(roles).forEach((role) => {
        if (role.account?.uuid) clinics.set(role.account.uuid, role.account);
    });

    return [...clinics.values()];
};

export const getRolesForClinic = (roles = [], clinicUuid) =>
    getMedicalRoles(roles).filter((role) => role.account?.uuid === clinicUuid);

export const resolveStoredAccess = ({ roles = [], roleUuid, clinic }) => {
    const medicalRoles = getMedicalRoles(roles);
    if (!roleUuid) {
        const storedClinic = clinic?.uuid
            ? getUniqueClinics(medicalRoles).find(
                  (availableClinic) => availableClinic.uuid === clinic.uuid
              )
            : null;
        return { isValid: false, role: null, clinic: storedClinic || null };
    }

    const role = medicalRoles.find((candidate) => candidate.uuid === roleUuid);
    if (!role) return { isValid: false, role: null, clinic: null };

    if (!role.account?.uuid) {
        return { isValid: true, role, clinic: null };
    }

    if (!clinic?.uuid || clinic.uuid !== role.account.uuid) {
        return { isValid: false, role: null, clinic: null };
    }

    return { isValid: true, role, clinic: role.account };
};
